import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/group-legal/")({
  beforeLoad: () => {
    throw redirect({ to: "/group-legal/dashboard", replace: true });
  },
});
